import { render, staticRenderFns } from "./EditCTABlockModal.vue?vue&type=template&id=13fa8532&lang=pug&"
import script from "./EditCTABlockModal.vue?vue&type=script&lang=js&"
export * from "./EditCTABlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports